<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/borrower/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="_borrowers">

          <template slot="header">
            <router-link :to="{name: 'customer-borrower-add'}" >
                <vs-button vs-order="5" radius color="primary" icon-pack="feather" icon="icon-plus" v-if="pms ('CustomerBorrower', 'create', 'b')"></vs-button>
            </router-link>
          </template>

          <template slot="thead">
            <vs-th sort-key="nameSurname">{{ $t("sections.customer.dataForm.project") }}</vs-th>
            <vs-th sort-key="nameSurname">{{ $t("sections.customer.dataForm.idCardNumber") }}</vs-th>
            <vs-th sort-key="nameSurname">{{ $t("sections.customer.dataForm.studentCode") }}</vs-th>
            <vs-th sort-key="nameSurname">{{ $t("sections.customer.dataForm.name") +" - "+ $t("sections.customer.dataForm.surname") }}</vs-th>
            <vs-th sort-key="status">{{ $t("sections.customer.dataForm.status") }}</vs-th>
            <vs-th sort-key="#" class="w-1/12"></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="row" :key="index" v-for="(row, index) in data">
              <vs-td :data="row.project">
                {{ row.project.nameTh }}
              </vs-td>
              <vs-td :data="row.idCardNumber">
                {{ row.idCardNumber }}
              </vs-td>
              <vs-td :data="row.studentCode">
                {{ row.studentCode }}
              </vs-td>
              <vs-td :data="row.fullName">
                {{ row.fullName }}
              </vs-td>
              <vs-td :data="row.status">
                <vs-chip :color="getStatusColor(row.status)" class="product-order-status">{{ row.status }}</vs-chip>
              </vs-td>
              <vs-td>
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-copy" v-if="pms ('CustomerBorrower', 'edit', 'b') && row.actions.edit" @click="copy(row.id)" ></vs-button>
                  <vs-button class="p-5" color="success" type="flat" icon-pack="feather" icon="icon-eye" v-if="pms ('CustomerBorrower', 'visible', 'b') && row.actions.view" @click="view(row.id)"></vs-button>
                  <vs-button class="p-5" color="warning" type="flat" icon-pack="feather" icon="icon-edit" v-if="pms ('CustomerBorrower', 'edit', 'b') && row.actions.edit" @click="edit(row.id)"></vs-button>
                  <vs-button class="p-5" color="danger" type="flat" icon-pack="feather" icon="icon-trash" v-if="pms ('CustomerBorrower', 'delete', 'b') && row.actions.delete" @click="del(row.id)" ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapCustomerActions, mapState: mapCustomerFields } = createNamespacedHelpers('Customer')

export default {
  async created() {
    await this.getBorrowers()
    this.pms ('CustomerBorrower', 'visible', 'r')
  },
  computed: {
    ...mapCustomerFields([
      'borrowers',
      'borrower',
      'status'
    ]),
    _borrowers() {
      if(this.borrowers) {
        return this.borrowers
      }
      return []
    }
  },
  methods: {
    ...mapCustomerActions(['getBorrowers', 'getBorrower', 'deleteBorrower', 'forceDeleteBorrower', 'createSurety']),
    async copy (id) {
      const vm = this
      await this.getBorrower({form: {id}}); // vm.borrowers.find(res => res.id === id);
      const { createSurety } = vm
      const surety = vm.borrower;
      createSurety({
        form: {
          prefix: {id: (surety.prefix ? surety.prefix.id : "") },
          name: surety.name,
          surname: surety.surname,
          birthDay: surety.birthDay,
          idCardNumber: surety.idCardNumber,
          issueDate: surety.issueDate,
          expDate: surety.expDate,
          career: surety.career,
          position: surety.position,
          affiliate: surety.affiliate,
          address: {
              location: surety.address.location,
              houseNumber: surety.address.houseNumber,
              moo: surety.address.moo,
              alley: surety.address.alley,
              road: surety.address.road,
              subDistrict: surety.address.subDistrict,
              district: surety.address.district,
              province: surety.address.province,
              zipcode: surety.address.zipcode,
              locationDoc: surety.address.locationDoc,
              houseNumberDoc: surety.address.houseNumberDoc,
              mooDoc: surety.address.mooDoc,
              alleyDoc: surety.address.alleyDoc,
              roadDoc: surety.address.roadDoc,
              subDistrictDoc: surety.address.subDistrictDoc,
              districtDoc: surety.address.districtDoc,
              provinceDoc: surety.address.provinceDoc,
              zipcodeDoc: surety.address.zipcodeDoc,
          },
          phone: surety.phone,
          mobile: surety.mobile,
          email: surety.email,
          status: surety.status
        },
        vm,
        noRedirect: true
      })
    },
    async view (id) {
      await this.$router.push({ name: 'customer-borrower-view', params: {id: id} })
    },
    async edit (id) {
      await this.$router.push({ name: 'customer-borrower-edit', params: {id: id} })
    },
    async del (id) {
      const vm = this
      const { $vs, deleteBorrower } = vm
      const { dialog } = $vs
      dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteBorrower({form: {id}, vm})
        }
      })
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
}
</script>
